import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React, { ReactNode } from "react";
import { CardBody, CardSubtitle, CardTitle } from "reactstrap";
import { MORE_INFO_SOCIAL } from "../../../constants/modal.constant";
import { useGlobalCore } from "../../../cores/globals";
import { SocialProvider } from "../../../cores/socialPost/interfaces/socialProvider";
import { LoadingSpinner } from "../LoadingSpinner";
import { PanelWembii } from "../PanelWembii";
import { YoutubeModal } from "../YoutubeModal";

interface Props {
  social: SocialProvider;
  children?: ReactNode;
  bindLoading?: boolean;
  getLoading?: boolean;
  title?: string;
  videoId?: string;
  showSynchronizer?: boolean;
}

export default function SocialCard({
  social,
  children,
  bindLoading,
  getLoading,
  videoId, 
  title,
  showSynchronizer = true
}: Props) {
  const { id, name, email, description, icon, avatar, displayName, url } = social;
  const { turnOnModal } = useGlobalCore();

  return (
    <PanelWembii
      key={id}
      shadow
      className="align-content-center border-0 justify-content-center px-2 py-2 text-center"
      style={{ height: "277px", width: "260px" }}
    >
      <CardBody className="p-2 d-flex flex-column">
        {showSynchronizer &&
          <div>
            <FontAwesomeIcon
              icon={["fas", "info-circle"]}
              style={{left: 100, bottom: 8, zIndex: 1}}
              className="pointer position-relative"
              size="lg"
              color="grey"
              onClick={() => turnOnModal(MORE_INFO_SOCIAL, 
                <YoutubeModal title={title!} videoId={videoId!} />
              )}     
            />
          </div>
        }
        <CardTitle 
          className="font-weight-bolder position-relative"
          style={{bottom: showSynchronizer ? 24 : 0}}
        >
          {name}
        </CardTitle>
        <div className={cn("position-relative my-auto")}>
          {icon}
          <div className="socialCard-avatar-container">
            <LoadingSpinner active={getLoading}>
              {avatar && (
                <img className="socialCard-avatar" src={avatar} alt="avatar" />
              )}
            </LoadingSpinner>
          </div>
        </div>
        {displayName && (
          <CardSubtitle className="truncate">{displayName}</CardSubtitle>
        )}
        {url && (
          <span className="small truncate mb-2">
            <a href={url} target="_black">
              {url}
            </a>
          </span>
        )}
        {email && (
          <span className="small truncate mb-2">
            {email}
          </span>
        )}
        <div className="d-flex mt-auto">
          <CardSubtitle className="truncate">{description}</CardSubtitle>
          <LoadingSpinner active={bindLoading}>{children}</LoadingSpinner>
        </div>
      </CardBody>
    </PanelWembii>
  );
}
